import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setShowGlobalLoader } from "Slices/appState";
import { fetchGetFleets, getIsFleetsLoaded } from "Slices/fleets";
import {
  fetchGetVehicleTypes,
  getIsVehicleTypesLoadingError,
} from "Slices/vehicleTypes";
import { getIsVehicleTypesLoaded } from "Slices/vehicleTypes";
import { getIsFleetsLoadingError } from "Slices/fleets/selectors";
import { setErrorWarning } from "Slices/warning";
import {
  fetchGetVehicles,
  getIsVehiclesLoaded,
  getIsVehiclesLoadingError,
} from "Slices/vehicles";
import { ChildrenProps } from "Utils/types";
import { getServerErrorMessage } from "Utils";

const useHandleDataLoadingErrors = () => {
  const dispatch = useDispatch();
  const isVehicleTypesLoadingError = useSelector(getIsVehicleTypesLoadingError);
  const isFleetsLoadingError = useSelector(getIsFleetsLoadingError);
  const isVehiclesLoadingError = useSelector(getIsVehiclesLoadingError);

  useEffect(() => {
    if (
      isVehicleTypesLoadingError ||
      isFleetsLoadingError ||
      isVehiclesLoadingError
    ) {
      const problemData = `
       ${isVehicleTypesLoadingError ? "VEHICLE TYPES" : ""}
       ${isFleetsLoadingError ? "FLEETS" : ""}
       ${isVehiclesLoadingError ? "VEHICLES" : ""}
      `.trim();

      dispatch(setShowGlobalLoader(false));
      dispatch(setErrorWarning(getServerErrorMessage(problemData)));
    }
  }, [
    isVehicleTypesLoadingError,
    isFleetsLoadingError,
    isVehiclesLoadingError,
  ]);
};

export const VehiclesListLoader = ({ children }: ChildrenProps) => {
  const dispatch = useDispatch();
  const isVehicleTypesLoaded = useSelector(getIsVehicleTypesLoaded);
  const isFleetsLoaded = useSelector(getIsFleetsLoaded);
  const isVehiclesLoaded = useSelector(getIsVehiclesLoaded);

  useHandleDataLoadingErrors();

  // GET /vehicleTypes
  useEffect(() => {
    if (isVehicleTypesLoaded) return;
    dispatch(setShowGlobalLoader(true));
    dispatch(fetchGetVehicleTypes());
  }, [isVehicleTypesLoaded]);

  // GET /fleets
  useEffect(() => {
    if (isFleetsLoaded) return;
    dispatch(setShowGlobalLoader(true));
    dispatch(fetchGetFleets());
  }, [isFleetsLoaded]);

  // GET /vehicles
  useEffect(() => {
    if (isVehiclesLoaded) return;
    dispatch(setShowGlobalLoader(true));
    dispatch(fetchGetVehicles());
  }, [isVehiclesLoaded]);

  // turn the loader off
  useEffect(() => {
    if (isFleetsLoaded && isVehicleTypesLoaded && isVehiclesLoaded) {
      dispatch(setShowGlobalLoader(false));
    }
  }, [isFleetsLoaded, isVehicleTypesLoaded, isVehiclesLoaded]);

  return <>{children}</>;
};
